import { render, staticRenderFns } from "./FormData.vue?vue&type=template&id=e4714a14&scoped=true"
import script from "./FormData.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormData.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FormData.vue?vue&type=style&index=0&id=e4714a14&prod&scoped=true&lang=scss"
import style1 from "./FormData.vue?vue&type=style&index=1&id=e4714a14&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4714a14",
  null
  
)

export default component.exports